/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Backend service
 */

namespace Application.Services {
    'use strict';

    export enum CallType {
        get,
        post,
        put,
        delete
    }

    /**
     * BackendService
     */
    export class BackendService {
        public static $name: string = "backendService";
        public static $inject: string[] = ['$http',
            '$q',
            '$timeout',
            '$interval',
            '$rootScope',
            "$window",
            'base64',
            '$location',
            'loginService',
            'messageTranslationsService',
        ];
        public static SECONDS_TO_RETRY: number = 10;
        public static NUMBER_OF_RETRIES: number = 5;

        private backendBaseUrl: string = window.backendUrl;
        private healthUrl: string = this.backendBaseUrl + "health";
        private intervalPromise: ng.IPromise<void>;
        private timeoutPromise: ng.IPromise<void>;

        constructor(private $http: ng.IHttpService,
                    private $q: ng.IQService,
                    private $timeout: ng.ITimeoutService,
                    private $interval: ng.IIntervalService,
                    private $rootScope: IFlexRootScope,
                    private $window: ng.IWindowService,
                    private base64: Base64Service,
                    private $location: ng.ILocationService,
                    private loginService: Services.LoginService,
                    private messageTranslationsService: Services.MessageTranslationsService) {
            // empty constructor
        }

        /**
         * TODO: Apply the boolean parameters here and in the others backendService methods.
         */
        public get<T>(url: string, 
                      retry?: boolean,
                      deferred?: ng.IDeferred<{}>,
                      showInfo: boolean = false,
                      showErr: boolean = true): ng.IPromise<{}> {
            let returnPath: string = this.$location.path();
            if (!deferred) deferred = this.$q.defer();
            if (url !== undefined && url !== '') {
                if (showInfo) {
                    Common.Utils.closeStickyAlerts();
                    Common.Utils.stickyAlert("Loading...", "info", BackendService.SECONDS_TO_RETRY);
                }
                // get call with retry
                if (retry !== undefined && retry === true) {
                    let retriesLeft: number = BackendService.NUMBER_OF_RETRIES;
                    this.$http.get(url)
                        .then((result: ng.IHttpPromiseCallbackArg<{}>) => {
                            this.$rootScope.$broadcast('isBackendPresent', true);
                            if (showInfo) Common.Utils.closeStickyAlerts();
                            deferred.resolve(result);
                        })
                        .catch((reason: ngCustom.IReason): ng.IPromise<{}> => {
                            let statusManaged = this.manageHttpResponse(reason, returnPath, deferred);
                            if(!statusManaged) {
                                return this.checkHealthWithRetry(showErr, url, deferred, reason, CallType.get);
                            }
                        });
                    // get call without retry
                } else {
                    this.$http.get(url)
                        .then((response: ng.IHttpPromiseCallbackArg<{}>) => {
                            this.$rootScope.$broadcast('isBackendPresent', true);
                            // .Common.Utils.closeStickyAlerts();
                            deferred.resolve(response);
                        })
                        .catch((reason: ngCustom.IReason) => {
                            let statusManaged = this.manageHttpResponse(reason, returnPath, deferred, showErr);
                            if(statusManaged) {
                                this.displayError(showErr, deferred, reason);
                            }
                        });
                }
            } else {
                deferred.reject();
            }
            return deferred.promise;
        }

        public simpleGet<T>(url: string): ng.IPromise<ng.IHttpPromiseCallbackArg<T>> {
            return this.$http.get(url)
                .then((response: ng.IHttpPromiseCallbackArg<T>) => {
                    this.$rootScope.$broadcast('isBackendPresent', true);
                    return response;
                });
        }

        public simplePost<T>(url:string, data: string | number): ng.IPromise<ng.IHttpPromiseCallbackArg<T>>{
            return this.$http
            .post(url, data)
            .then((response: ng.IHttpPromiseCallbackArg<T>) => {
                this.$rootScope.$broadcast('isBackendPresent', true);
                return response;
            });
        }

        public post<T>(url: string, data: Object, retry?: boolean, deferred?: ng.IDeferred<{}>, showErr: boolean = true): ng.IPromise<{}> {
            let returnPath: string = this.$location.path();
            if (!deferred) deferred = this.$q.defer();
            if (url !== undefined && url !== '' && data !== undefined) {
                // .Common.Utils.closeStickyAlerts();
                // .Common.Utils.stickyAlert("Loading...", "info");
                // post call with retry
                if (retry !== undefined && retry === true) {
                    let retriesLeft: number = BackendService.NUMBER_OF_RETRIES;
                    this.$http
                        .post(url, data)
                        .then((result: ng.IHttpPromiseCallbackArg<{}>) => {
                            this.$rootScope.$broadcast('isBackendPresent', true);
                            // .Common.Utils.closeStickyAlerts();
                            deferred.resolve(result);
                        })
                        .catch((reason: ngCustom.IReason): ng.IPromise<{}> => {
                            let statusManaged = this.manageHttpResponse(reason, returnPath, deferred, false);
                            if(!statusManaged) {
                                return this.checkHealthWithRetry(showErr, url, deferred, reason, CallType.get);
                            }
                        });
                    // post call without retry
                } else {
                    this.$http
                        .post(url, data)
                        .then((response: ng.IHttpPromiseCallbackArg<{}>) => {
                            this.$rootScope.$broadcast('isBackendPresent', true);
                            // .Common.Utils.closeStickyAlerts();
                            deferred.resolve(response);
                        })
                        .catch((reason: ngCustom.IReason) => {
                            let statusManaged = this.manageHttpResponse(reason, returnPath, deferred);
                            if(!statusManaged) {
                                this.displayError(showErr, deferred, reason);
                            }
                        });
                }
                return deferred.promise;
            }
        }

        public put<T>(url: string, data: Object, retry?: boolean, deferred?: ng.IDeferred<{}>, showErr: boolean = true): ng.IPromise<{}> {
            let returnPath: string = this.$location.path();
            if (!deferred) deferred = this.$q.defer();
            if (url !== undefined && url !== '' && data !== undefined) {
                // .Common.Utils.closeStickyAlerts();
                // .Common.Utils.stickyAlert("Loading...", "info");
                // put call with retry
                if (retry !== undefined && retry === true) {
                    let retriesLeft: number = BackendService.NUMBER_OF_RETRIES;
                    this.$http
                        .put(url, data)
                        .then((result: ng.IHttpPromiseCallbackArg<{}>) => {
                            this.$rootScope.$broadcast('isBackendPresent', true);
                            // .Common.Utils.closeStickyAlerts();
                            deferred.resolve(result);
                        })
                        .catch((reason: ngCustom.IReason): ng.IPromise<{}> => {
                            let statusManaged = this.manageHttpResponse(reason, returnPath, deferred, showErr);
                            if(!statusManaged) {
                                return this.checkHealthWithRetry(showErr, url, deferred, reason, CallType.put);
                            }
                        });
                    // put call without retry
                } else {
                    this.$http
                        .put(url, data)
                        .then((response: ng.IHttpPromiseCallbackArg<{}>) => {
                            this.$rootScope.$broadcast('isBackendPresent', true);
                            // .Common.Utils.closeStickyAlerts();
                            deferred.resolve(response);
                        })
                        .catch((reason: ngCustom.IReason) => {
                            let statusManaged = this.manageHttpResponse(reason, returnPath, deferred);
                            if (!statusManaged) {
                                this.displayError(showErr, deferred, reason);
                            }
                        });
                }
                return deferred.promise;
            }
        }

        public delete<T>(url: string, retry?: boolean, deferred?: ng.IDeferred<{}>): ng.IPromise<{}> {
            let returnPath: string = this.$location.path();
            if (!deferred) deferred = this.$q.defer();
            if (url !== undefined && url !== '') {
                // .Common.Utils.closeStickyAlerts();
                // .Common.Utils.stickyAlert("Loading...", "info");
                // delete call with retry
                if (retry !== undefined && retry === true) {
                    let retriesLeft: number = BackendService.NUMBER_OF_RETRIES;
                    this.$http
                        .delete(url)
                        .then((result: ng.IHttpPromiseCallbackArg<{}>) => {
                            this.$rootScope.$broadcast('isBackendPresent', true);
                            Common.Utils.closeStickyAlerts();
                            deferred.resolve(result);
                        })
                        .catch((reason: ngCustom.IReason): ng.IPromise<{}> => {
                            let statusManaged = this.manageHttpResponse(reason, returnPath, deferred);
                            if (!statusManaged) {
                                return this.checkHealthWithRetry(true, url, deferred, reason, CallType.delete);
                            }
                        });
                    // delete call without retry
                } else {
                    this.$http
                        .delete(url)
                        .then((response: ng.IHttpPromiseCallbackArg<{}>) => {
                            this.$rootScope.$broadcast('isBackendPresent', true);
                            // .Common.Utils.closeStickyAlerts();
                            deferred.resolve(response);
                        })
                        .catch((reason: ngCustom.IReason) => {
                            let statusManaged = this.manageHttpResponse(reason, returnPath, deferred);
                            if(!statusManaged) {
                                this.displayError(true, deferred, reason);
                            }
                        });
                }
                return deferred.promise;
            }
        }

        public waitReconnection(): ng.IPromise<{}> {
            this.$rootScope.$broadcast('isBackendPresent', false);
            return this.retryUntilCheckOk();
        }

        public pingHealth(): ng.IPromise<boolean> {
            if(this.timeoutPromise !== undefined){ //Health is being checked by other means
                return;
            }
            return this.$http.get(this.healthUrl).then(() => {
                return true;
            }).catch(() => {
                this.waitReconnection();
                return false;
            });
        }

        public checkHealth<T>(url: string,
                              retry: boolean,
                              deferred: ng.IDeferred<{}>,
                              callType: CallType,
                              retriesLeft: number,
                              data?: Object,
                              immediate?: boolean,
                              secondsToRetry = BackendService.SECONDS_TO_RETRY): ng.IPromise<{}> {
            Common.Utils.closeStickyAlerts();
            // Common.Utils.stickyAlert("Error accessing the data.", "danger", BackendService.SECONDS_TO_RETRY);
            retriesLeft--;
            if (retriesLeft > 0) {
                if (immediate) {
                    this.checkHealthHelper(callType, url, retry, deferred, data, retriesLeft);
                } else {
                    // this.retryCountDown();
                    if (this.timeoutPromise !== undefined)
                        this.$timeout.cancel(this.timeoutPromise);
                    this.timeoutPromise =
                        this.$timeout(() => {
                            this.checkHealthHelper(callType, url, retry, deferred, data, retriesLeft);
                        }, secondsToRetry * 1000);
                }
                return deferred.promise;
            }
        }

        public retryNTimes(url: string, retries: number, deferred?: ng.IDeferred<{}>): ng.IPromise<{}> {
            if (deferred === undefined)
                deferred = this.$q.defer();
            this.get(url, false, undefined, false, false).then(() => {
                deferred.resolve({});
            }).catch((reason: ngCustom.IReason) => {
                if (reason.status === -1)
                    deferred.resolve({});
                else {
                    if (retries > 0) {
                        this.$timeout(() => {
                            this.retryNTimes(url, --retries, deferred);
                        }, 5000);
                    } else {
                        deferred.reject(reason);
                    }
                }
            });
            return deferred.promise;
        }

        private checkHealthHelper(callType: Services.CallType,
                                  url: string,
                                  retry: boolean,
                                  deferred: angular.IDeferred<{}>,
                                  data: Object, retriesLeft: number): ng.IPromise<{}> {
            this.$http
                .get(this.healthUrl)
                .success(() => {
                    this.$rootScope.$broadcast('isBackendPresent', true);
                    if (callType === CallType.get)
                        return this.get(url, retry, deferred);
                    else if (callType === CallType.post && data !== undefined)
                        return this.post(url, data, retry, deferred);
                    else if (callType === CallType.put && data !== undefined)
                        return this.put(url, data, retry, deferred);
                    else if (callType === CallType.delete)
                        return this.delete(url, retry, deferred);
                })
                .catch(() => {
                    this.$rootScope.$broadcast('isBackendPresent', false);
                    return this.checkHealth(url, retry, deferred, callType, retriesLeft, data);
                });
            return deferred.promise;
        }

        private retryUntilCheckOk<T>(deferred?: ng.IDeferred<{}>): ng.IPromise<{}> {
            if (!deferred) deferred = this.$q.defer();
            Common.Utils.closeStickyAlerts();
            // Common.Utils.stickyAlertPos("Error accessing the data.", "warning", BackendService.SECONDS_TO_RETRY, 'top-center');
            // this.retryCountDown();
            if (this.timeoutPromise !== undefined)
                this.$timeout.cancel(this.timeoutPromise);
            this.timeoutPromise = this.$timeout(() => {
                this.$http
                    .get(this.healthUrl)
                    .success(() => {
                        this.$rootScope.$broadcast('isBackendPresent', true);
                        Common.Utils.closeStickyAlerts();
                        deferred.resolve();
                    })
                    .catch(() => {
                        this.$rootScope.$broadcast('isBackendPresent', false);
                        return this.retryUntilCheckOk(deferred);
                    });
            }, BackendService.SECONDS_TO_RETRY * 1000);
            return deferred.promise;
        }

        // tslint:disable-next-line:no-unused-variable
        private retryCountDown(): void {
            let seconds: number = BackendService.SECONDS_TO_RETRY;
            if (this.intervalPromise !== undefined)
                this.$interval.cancel(this.intervalPromise);
            this.intervalPromise =
                this.$interval(() => {
                    seconds -= 1;
                    $('#no-connection-warning span').text("Failed to connect. Retry on " + seconds + "...");
                }, 1000, BackendService.SECONDS_TO_RETRY);
        }

        private unauthenticated(returnPath: string): void {
            let login: string = this.$location.search().login;
            if (login !== undefined && login !== '') {
                console.log("Trying autologin");
                let password: string = this.$location.search().password; 
                this.loginService.doFormLogin(login, password, returnPath).then(() => {
                    this.loginService.isLoggedIn(returnPath);
                });
            } else if (this.$location.path().indexOf('/login') < 0) {
                this.$location.path('/login').search({ returnPath: returnPath });
            }
        }

        private manageHttpResponse<T>(response: ngCustom.IReason, returnPath: string, deferred?: ng.IDeferred<{}>, showInfo: boolean = false): boolean {
            // Url Found
            if (response.status === 302) {
                this.unauthenticated(returnPath);
                Common.Utils.closeStickyAlerts();
                deferred.reject(response);
            } else if (response.status === 400) {
                this.$rootScope.$broadcast('isErrorMessagePresent', true);
                if (showInfo) this.messageTranslationsService.showPromiseError(response);
                deferred.reject(response);
            } else if (response.status === 401) {
                this.$timeout(() => {
                    this.$rootScope.vars.isUserLoggedIn = false;
                });
                this.unauthenticated(returnPath);
                if (showInfo) Common.Utils.closeStickyAlerts();
                deferred.reject(response);
            } else if (response.status === 403) {
                if (showInfo) this.messageTranslationsService.showPromiseError(response);
                deferred.reject(response);
            } else if (response.status === 404) {
                // TO DO error handling, should be improved
                // this.$rootScope.$broadcast('isBackendPresent', false);
                if (showInfo) this.messageTranslationsService.showPromiseError(response);
                deferred.reject(response);
            } else {
                if (showInfo) this.messageTranslationsService.showPromiseError(response);
                deferred.reject(response);
            }
            return true;
        }


        private checkHealthWithRetry(showErr: boolean = false, url: string, deferred: ng.IDeferred<{}>, reason: ngCustom.IReason, callType: CallType): ng.IPromise<{}>  {
            let retriesLeft: number = BackendService.NUMBER_OF_RETRIES;
            retriesLeft--;
            this.$rootScope.$broadcast('isBackendPresent', false);
            if (retriesLeft > 0) {
                return this.checkHealth(url, true, deferred, callType, retriesLeft);
            } else {
                if (showErr) this.messageTranslationsService.showPromiseError(reason);
                deferred.reject(reason);
            }
        }

        private displayError(showErr: boolean = false, deferred: ng.IDeferred<{}>, reason: ngCustom.IReason)  {
            if (showErr) this.messageTranslationsService.showPromiseError(reason);
            deferred.reject(reason);
        }

    }

    /*
     * We need to store every request even though is for the same id because
     * different UI components could be waiting from the same id and we need
     * to notify each one when the promise is resolved
     */
    export interface IdDeferredRequestMap {
        [key: number]: DeferredRequest[];
    }

    export class DeferredRequest {
        constructor(public id: number,
                    public deferred: ng.IDeferred<any>,  // tslint:disable-line:no-any
                    public subUrl?: string) { //tslint:disable-line
        }

    }



}
